<template>
  <div class="box">

  </div>
</template>

<script>
export default {
  name: "SidebarBackground"
}
</script>

<style scoped>
  .box{
    position: absolute;
    background: rgba(97, 0, 95, 0.7);
    height: 100%;
    z-index: -99;
    width: 20%;
    left: 0;
  }
</style>